(function () {
  function openLightbox(modal, trigger) {
    modal.hidden = false;
    modal._trigger = trigger;
    document.body.style.overflow = 'hidden';
    var closeBtn = modal.querySelector('.policy-lightbox__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeLightbox(modal) {
    modal.hidden = true;
    document.body.style.overflow = '';
    var img = modal.querySelector('.policy-lightbox__img');
    if (img) {
      img.src = '';
      img.alt = '';
    }
    if (modal._trigger) {
      modal._trigger.focus();
      modal._trigger = null;
    }
  }

  function trapFocus(modal, e) {
    var focusable = Array.from(
      modal.querySelectorAll('button:not([disabled]), a[href]')
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  document.querySelectorAll('.policy-list__zoom').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var modal = document.getElementById(btn.dataset.lightbox);
      if (!modal) return;
      var img = modal.querySelector('.policy-lightbox__img');
      if (img) {
        img.src = btn.dataset.zoomSrc || '';
        img.alt = btn.dataset.zoomAlt || '';
      }
      openLightbox(modal, btn);
    });
  });

  document.querySelectorAll('.policy-lightbox').forEach(function (modal) {
    modal.querySelectorAll('[data-close-lightbox]').forEach(function (el) {
      el.addEventListener('click', function () { closeLightbox(modal); });
    });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeLightbox(modal); return; }
      if (e.key === 'Tab') trapFocus(modal, e);
    });
  });
})();
